import { Alert, Platform } from 'react-native';

// Use window alert for browser & react native alert for mobile
const alertPolyfill = (title, description, options, extra) => {
    const result = window.confirm([title, description].filter(Boolean).join('\n'));

    if (result) {
        const confirmOption = options.find(({ style }) => style !== 'cancel');
        confirmOption && confirmOption.onPress();
    } else {
        const cancelOption = options.find(({ style }) => style === 'cancel');
        cancelOption && cancelOption.onPress();
    }
}
const CustomAlert = Platform.OS === 'web' ? alertPolyfill : Alert.alert;

export default CustomAlert;